// extracted by mini-css-extract-plugin
export default {"calculateBox":"style_calculateBox__1TV3I","calculateInput":"style_calculateInput__plzQq","calculateRessultText":"style_calculateRessultText__Zs+Wo"};